import { forwardRef, useState, useImperativeHandle, useEffect, useRef } from 'react'
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  FormControl,
  Grid,
  InputLabel,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Select,
  TextField,
  Typography,
  OutlinedInput
} from '@mui/material'
import './ephTracker.css'
import DateTranslatedPicker from './datePicker'
import {DifferenceOutlined, Merge} from '@mui/icons-material'
import SearchIcon from '@mui/icons-material/Search'
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Storage from '../../session/storage'
import api from '../../service/api'
import PopUpMsg from '../../config/popUpMsg.json'

const TrackerFilter = forwardRef((props, ref) => {
  var todayDate= new Date()
  const [maxDate, setMaxDate] = useState(`${todayDate.getFullYear()}/${todayDate.getMonth() < 9 ? '0' + (todayDate.getMonth() + 1 ):(todayDate.getMonth() + 1) }/${todayDate.getDate() < 10 ? '0' + todayDate.getDate() : todayDate.getDate()}`)
  const [minDate] = useState('2024/11/27')
  const [searchData, setSearchData] = useState(props.searchedData)
  const [showError, setShowError] = useState(false)
  const childRef = useRef()
  const [selectedIndex, setSelectedIndex] = useState(props.selectedTab);
  const options = [
    'DCR',
    'Merge'    
  ];

  const [countryList,setCountryList] = useState(Storage.getAllCountryList())
  const [isFocused, setIsFocused] = useState(false)

  useImperativeHandle(ref, () => ({
    clearAll
  }))

  // fetch user access specific country list if no availble in Storage file
  useEffect(()=>{
    if(countryList === null || countryList === undefined){
      props.setLoading(true);
      async function fetchDetails() {
        await api.getSelectedDCRCountry().then((countryList) => {
          var countryListData = countryList.data
          Storage.setAllCountryList(countryList.data)
          setCountryList(countryListData.map(item => item.split('#')[0]))
          setTimeout(() => {
            props.setLoading(false);
          }, 2000);
        }).catch((error) => {
            props.setLoading(false);
        })
      }
      fetchDetails();
    }
    countryList && setCountryList(countryList.map(item => item.split('#')[0]));  
  },[])

  useEffect(()=>{
    setSearchData(props.searchedData)
  },[props.searchedData])

  useEffect(() => {
    if(props.selectRef) {
      props.selectRef.current.focus() // Focus on the select element when the component mounts
    }
  }, [props.selectRef])

  // fetch user access specific country list if no availble in Storage file
  useEffect(()=>{
    if(countryList === null || countryList === undefined){
      props.setLoading(true);
      async function fetchDetails() {
        await api.getSelectedDCRCountry().then((countryList) => {
          var countryListData = countryList.data
          Storage.setAllCountryList(countryList.data)
          setCountryList(countryListData.map(item => item.split('#')[0]))
          setTimeout(() => {
            props.setLoading(false);
          }, 2000);
        }).catch((error) => {
            props.setLoading(false);
        })
      }
      fetchDetails();
    }
    countryList && setCountryList(countryList.map(item => item.split('#')[0]));  
  },[])

  /**
   * handling data inserted into the form fields
   */
  const handleSearch = (event, id, type) => {


    if (type == 'date') {

      const year = event?.$y
      const month = event?.$M < 9 ? '0' + (event?.$M + 1) : event?.$M + 1
      const day = event?.$D < 10 ? '0' + event?.$D : event?.$D

      setSearchData({...searchData, [selectedIndex]:{...searchData[selectedIndex], [id]: `${year}-${month}-${day}`}})

      if (id == 'startDate') {
        // setMinDate(`${year}/${month}/${day}`) 
        setMaxDate(`${todayDate.getFullYear()}/${todayDate.getMonth() < 9 ? '0' + (todayDate.getMonth() + 1 ):(todayDate.getMonth() + 1) }/${todayDate.getDate() < 10 ? '0' + todayDate.getDate() : todayDate.getDate()}`)   
        // code to check if diffrence between start date and end date is more than 3 months
        const startDate = new Date(`${year}-${month}-${day}`);
        const endDate = new Date(`${todayDate.getFullYear()}-${todayDate.getMonth() < 9 ? '0' + (todayDate.getMonth() + 1 ):(todayDate.getMonth() + 1) }-${todayDate.getDate() < 10 ? '0' + todayDate.getDate() : todayDate.getDate()}`);
        const diffTime = Math.abs(endDate - startDate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if (diffDays > 90) {
          props.setOpenSnackBar(true)
          props.setSnackMessage({'type': 'warning', 'message': PopUpMsg.ephInbox[0].filterChanges.performanceImpact})
          setTimeout(() => {
            props.setOpenSnackBar(false)
          }, 3000);
        }
      } else if (id == 'endDate') {
        setMaxDate(`${year}/${month}/${day}`)
      }
    } else if (type == 'interval') {

      let endDate = todayDate.getFullYear() + '-' + (todayDate.getMonth() < 9 ? '0' + (todayDate.getMonth() + 1) : (todayDate.getMonth() + 1)) + '-' + (todayDate.getDate() < 10 ? '0' + todayDate.getDate() : todayDate.getDate())
      let startDate = ''
      if (event.target.value === 'Last 7 Days') {
        startDate = new Date(todayDate.getTime() - (7 * 24 * 60 * 60 * 1000))
        startDate = startDate.getFullYear() + '-' + (startDate.getMonth() < 9 ? '0' + (startDate.getMonth() + 1) : (startDate.getMonth() + 1)) + '-' + (startDate.getDate() < 10 ? '0' + startDate.getDate() : startDate.getDate())
      }
      else if (event.target.value === 'Last 15 Days') {
        startDate = new Date(todayDate.getTime() - (15 * 24 * 60 * 60 * 1000))
        startDate = startDate.getFullYear() + '-' + (startDate.getMonth() < 9 ? '0' + (startDate.getMonth() + 1) : (startDate.getMonth() + 1)) + '-' + (startDate.getDate() < 10 ? '0' + startDate.getDate() : startDate.getDate())
      } else if (event.target.value === 'Last 1 Month') {
        startDate = new Date(todayDate.getFullYear(), todayDate.getMonth() - 1, todayDate.getDate())
        startDate = startDate.getFullYear() + '-' + (startDate.getMonth() < 9 ? '0' + (startDate.getMonth() + 1) : (startDate.getMonth() + 1)) + '-' + (startDate.getDate() < 10 ? '0' + startDate.getDate() : startDate.getDate())
      } else if (event.target.value === 'Last 3 Months') {  
        startDate = new Date(todayDate.getFullYear(), todayDate.getMonth() - 3, todayDate.getDate())
        startDate = startDate.getFullYear() + '-' + (startDate.getMonth() < 9 ? '0' + (startDate.getMonth() + 1) : (startDate.getMonth() + 1)) + '-' + (startDate.getDate() < 10 ? '0' + startDate.getDate() : startDate.getDate())
      }
      setSearchData({...searchData, [selectedIndex]:{...searchData[selectedIndex], [event.target.name]: event.target.value ,startDate: startDate, endDate: endDate}})
      if (id == 'timeInterval') {
        setMaxDate(endDate)
      }
    }
     else {    
      setSearchData({...searchData, [selectedIndex]:{...searchData[selectedIndex], [event.target.name]: event.target.value }})  
    }

  }
  async function handleDcrSearch () {    
    if(Object.keys(searchData[selectedIndex]).length > 0){
      props.onQuery(searchData)
      setShowError(false)
    }else{
      setShowError(true)
    }    
  }

  const handleMenuItemClick = (option) => {
    setSelectedIndex(option);
    props.handleTabChange(option)

  };

  /**
   * clear all data from form fields
   */
  async function clearAll() {
    props.handleFilterData()  
    let endDate = todayDate.getFullYear() + '-' + (todayDate.getMonth() < 9 ? '0' + (todayDate.getMonth() + 1) : (todayDate.getMonth() + 1)) + '-' + (todayDate.getDate() < 10 ? '0' + todayDate.getDate() : todayDate.getDate())
    let startDate = new Date(todayDate.getTime() - (7 * 24 * 60 * 60 * 1000))
    startDate = startDate.getFullYear() + '-' + (startDate.getMonth() < 9 ? '0' + (startDate.getMonth() + 1) : (startDate.getMonth() + 1)) + '-' + (startDate.getDate() < 10 ? '0' + startDate.getDate() : startDate.getDate())
    props.onQuery({...searchData, [selectedIndex]:{timeInterval:"Last 7 Days", startDate: startDate, endDate: endDate}})
    setSearchData({...searchData, [selectedIndex]:{timeInterval:"Last 7 Days", startDate: startDate, endDate: endDate}}) 
    setMaxDate('')
    setShowError(false)
    if (childRef.current) {
      childRef.current.clearAll()
    }
  }

  return (
    <>
      <Card sx={{boxShadow: 3 }}>
      <CardContent className='p-0'>
      <MenuList className='p-0'>

      {
        options.map((option,index) => (
          <MenuItem
            key={option}            
            selected={option === selectedIndex}
            onClick={(event) => handleMenuItemClick(option)}
            divider={index == 0}
            sx={{
              '&.Mui-selected': {
                backgroundColor: '#dc1c1c',
                color: 'white',
                
              },
              '&.Mui-selected:hover': {
                backgroundColor: '#dc1c1c',
              }
            }}
          >
              <ListItemIcon sx={{color: 'inherit'}}> {option == 'DCR' ? <DifferenceOutlined fontSize='medium' /> :<Merge fontSize="medium" /> }
               </ListItemIcon>
              <ListItemText>{option} Requests</ListItemText>
              
              <Typography variant="body2" sx={{ color: 'inherit' }}>
                    <NavigateNextIcon sx={{color: 'inherit'}} />
          
          </Typography>
          </MenuItem>

        ))}        

      </MenuList>
      
     </CardContent>
     </Card>
      <Card className='mt-2' sx={{maxHeight: '72vh' , boxShadow: 3, flexGrow: 1, overflowY: 'auto', overflowX: ' hidden'}}>
      <CardContent className='p-2' >
        <Typography variant='h6' component='p' align='center' className='_wg-dynamic-text mt-1'>
          <SearchIcon sx={{width: 25, height:25}} /> &nbsp;Advanced Search
        </Typography>
          <Grid item md={12} sm={12} xs={12}>
            <Box
              className='mt-3 _wg-dynamic-text'
              sx={{
                transition: 'box-shadow 0.3s ease',
                borderRadius: '4px',
                boxShadow: isFocused && props.highlight
                  ? "0 6px 8px rgba(25, 118, 210, 0.4), -3px 0 4px rgba(25, 118, 210, 0.2), 3px 0 4px rgba(25, 118, 210, 0.2)"
                  : "none",
              }}>
            <FormControl fullWidth className='_wg-dynamic-text' size='small' variant='outlined'
              // sx={{'& .MuiOutlinedInput-root': { '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#1976D2', borderWidth:'3px' } }}}

              >
              <InputLabel id='dcr-action'>Time Interval</InputLabel>
              <Select
                labelId='dcr-action'
                id='action'
                value={searchData ? searchData[selectedIndex]['timeInterval'] || '' : ''}
                label='Time Interval'
                name='timeInterval'
                onChange={(event, name) => handleSearch(event, name, "interval")}
                className='_wg-dynamic-text'
                inputRef={props.selectRef}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                onClick={props.onUserInteraction}
                input={
                  <OutlinedInput
                    label='Time Interval'
                  />}
              >
                <MenuItem className='_wg-dynamic-text' value={'Last 7 Days'}>Last 7 Days</MenuItem>
                <MenuItem className='_wg-dynamic-text' value={'Last 15 Days'}>Last 15 Days</MenuItem>
                <MenuItem className='_wg-dynamic-text' value={'Last 1 Month'}>Last 1 Month</MenuItem>
                <MenuItem className='_wg-dynamic-text' value={'Last 3 Months'}>Last 3 Months</MenuItem>
                <MenuItem className='_wg-dynamic-text' value={'Custom'}>Custom</MenuItem>
              </Select>
            </FormControl>
            </Box>            
          </Grid>
          {searchData && searchData[selectedIndex] && searchData[selectedIndex]['timeInterval'] === 'Custom' && 
            <Grid container spacing={2}>
              <Grid item md={6} sm={6} xs={6}>

                <DateTranslatedPicker
                  id="startdate"
                  label='Start Date'
                  minDate={minDate}
                  maxDate={maxDate}
                  name='startDate'
                  value={searchData[selectedIndex]?.startDate ?? null}
                  // value={searchData && searchData[selectedIndex]['startDate'] ? (searchData[selectedIndex]['startDate']) : null}
                  handleSearch={(event, name, type) => handleSearch(event, name, type)}
                  className='admin-tracker-input mt-3'
                />
              </Grid>
              <Grid item md={6} sm={6} xs={6}>
                <DateTranslatedPicker
                  id="enddate"
                  label='End Date'
                  maxDate={`${todayDate.getFullYear()}/${todayDate.getMonth() < 9 ? '0' + (todayDate.getMonth() + 1) : (todayDate.getMonth() + 1)}/${todayDate.getDate() < 10 ? '0' + todayDate.getDate() : todayDate.getDate()}`}
                  minDate={minDate}
                  name='endDate'
                  value={searchData[selectedIndex]?.endDate ?? null}
                  // value={searchData && searchData[selectedIndex]['endDate'] ? (searchData[selectedIndex]['endDate']) : null}
                  handleSearch={(event, name, type) => handleSearch(event, name, type)}
                  className='admin-tracker-input mt-3'

                />
              </Grid>

            </Grid>
          }
        <Grid container>
          {/* <Grid item md={12} sm={12} xs={12}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                id='startdate'
                label='Start Date'
                slotProps={{ textField: { fullWidth: true, size: 'small' } }}
                views={['year', 'month', 'day']}
                maxDate={dayjs(maxDate)}
                name='startDate'
                value={searchData && searchData.startDate ? dayjs(searchData.startDate) : null}
                onChange={event => handleSearch(event, 'startDate', 'date')}
                className='admin-tracker-input mt-3'
                InputLabelProps={{ style: { color: 'black' } }}
              />
            </LocalizationProvider>
          </Grid>

          <Grid item md={12} sm={12} xs={12}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                id='enddate'
                label='End Date'
                slotProps={{ textField: { fullWidth: true, size: 'small' } }}
                views={['year', 'month', 'day']}
                minDate={dayjs(minDate)}
                maxDate={dayjs(maxDate)}
                value={searchData && searchData.endDate ? dayjs(searchData.endDate) : null}
                name='endDate'
                onChange={event => handleSearch(event, 'endDate', 'date')}
                className='admin-tracker-input mt-3'
                InputLabelProps={{ style: { color: '#333333' } }}
              />
            </LocalizationProvider>
          </Grid> */}

          <Grid item md={12} sm={12} xs={12}>
            <TextField
              fullWidth
              id='dcrId'
              label={selectedIndex == 'DCR' ? 'DCR Id' : 'Merge Id'}
              variant='outlined'
              size='small'
              value={searchData ? searchData[selectedIndex]['dcrId'] || '' : ''}
              name={'dcrId'}
              onChange={handleSearch}
              className='mt-3 _wg-dynamic-text'
            />
          </Grid>

          <Grid item md={12} sm={12} xs={12}>
            <TextField
              fullWidth
              id='createdBy'
              label='Created By User Id'
              variant='outlined'
              size='small'
              value={searchData ? searchData[selectedIndex]['userId'] || '' : ''}
              name='userId'
              onChange={handleSearch}
              className='mt-3 _wg-dynamic-text'
            />
          </Grid>

          <Grid item md={12} sm={12} xs={12}>
            <TextField
              fullWidth
              id='createdByEmail'
              label='Created By Email'
              variant='outlined'
              size='small'
              value={searchData ? searchData[selectedIndex]['emailId'] || '' : ''}
              name='emailId'
              onChange={handleSearch}
              className='mt-3 _wg-dynamic-text'
            />
          </Grid>

          <Grid item md={12} sm={12} xs={12}>
            <FormControl fullWidth className='mt-3 _wg-dynamic-text' size='small'>
              <InputLabel id='dcr-action'>Status</InputLabel>
              <Select
                labelId='dcr-action'
                id='action'
                value={searchData ? searchData[selectedIndex]['dcrStatus'] || '' : ''}
                label='Status'
                name='dcrStatus'
                onChange={handleSearch}
                className='_wg-dynamic-text'
              >
                <MenuItem className='_wg-dynamic-text' value=''>
                  <em>All</em>
                </MenuItem>
                <MenuItem className='_wg-dynamic-text' value={'Approved'}>Approved</MenuItem>   
                <MenuItem className='_wg-dynamic-text' value={'Applied'}>Applied</MenuItem>   
                <MenuItem className='_wg-dynamic-text' value={'Requested'}>Requested</MenuItem>
                <MenuItem className='_wg-dynamic-text' value={'Rejected'}>Rejected</MenuItem>
                <MenuItem className='_wg-dynamic-text' value={'Unassigned'}>Unassigned</MenuItem>             
              </Select>
            </FormControl>
          </Grid>

           {/* Filter for country using lov values */}
            {
              countryList && <Grid item md={12} sm={12} xs={12}>
                <FormControl fullWidth className='mt-3 _wg-dynamic-text' size='small'>
                  <InputLabel id='dcr-action'>Country</InputLabel>
                  <Select
                    labelId='dcr-action'
                    id='action'
                    value={searchData ? searchData[selectedIndex]['country'] || '' : ''}
                    label='Country'
                    name='country'
                    onChange={handleSearch}
                    className='_wg-dynamic-text'

                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: '200px',
                          width: 'auto',
                        },
                      },
                      getContentAnchorEl: null,
                      anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                      },
                      transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left',
                      },
                    }}


                  >
                    <MenuItem className='_wg-dynamic-text' value=''>
                      <em>All</em>
                    </MenuItem>
                    {countryList.filter((item, index) => countryList.indexOf(item) === index)
                      .map((country, index) => (
                         <MenuItem className='_wg-dynamic-text' key={index} value={country}>{country}</MenuItem>))}
                  </Select>
                </FormControl>
              </Grid>
       } 
       {selectedIndex == 'DCR' && <Grid item md={12} sm={12} xs={12}>
            <FormControl fullWidth className='mt-3 _wg-dynamic-text' size='small'>
              <InputLabel id='dcr-action'>DCR Source</InputLabel>
              <Select
                labelId='dcr-action'
                id='action'
                value={searchData ? searchData[selectedIndex]['dcrSource'] || '' : ''}
                label='DCR Source'
                name='dcrSource'
                onChange={handleSearch}
                className='_wg-dynamic-text'
              >
                <MenuItem className='_wg-dynamic-text' value=''>
                  <em>All</em>
                </MenuItem>
                <MenuItem className='_wg-dynamic-text' value={'ECS'}>ECS</MenuItem>   
                <MenuItem className='_wg-dynamic-text' value={'CRM'}>CRM</MenuItem>
                <MenuItem className='_wg-dynamic-text' value={'Consumer'}>Consumer</MenuItem>           
              </Select>
            </FormControl>
          </Grid>}
          

          {showError &&
          <Grid item md={12} sm={12} xs={12}>
            <Typography className='mt-2 text-danger _wg-dynamic-text' align='center' component={'p'}>Please add at least one field</Typography>            
          </Grid>
          }
        </Grid>
      </CardContent>
      <CardActions className='mb-2 pl-3 pr-3'>
        <Grid container spacing={1}>
          <Grid item textAlign={'center'} sm={12} md={6} xs={3.5}>
            <Button
              fullWidth
              className='btn btn-secondry border clearFilter'
              id='mergeButton'
              onClick={() => clearAll()}
            >
              Clear
            </Button>
          </Grid>
          <Grid item textAlign={'center'} sm={12} md={6} xs={3.5}>
            <Button
              fullWidth
              className='btn btn-secondry border searchButton'
              id='mergeButton'
              onClick={handleDcrSearch}
              disabled= {searchData[selectedIndex]['timeInterval'] === 'Custom' && (searchData[selectedIndex]['startDate'] === '' || searchData[selectedIndex]['endDate'] === '')}
            >
              Search
            </Button>
          </Grid>
        </Grid>
      </CardActions>
    </Card>
    
    </>
  )
})

export default TrackerFilter
